import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["prefixCls", "children", "separator", "className"];
import * as React from 'react';
import { cloneElement } from 'react';
import ClassNames from 'classnames';
import { useLocalization } from '@appkit4/react-api';
var Breadcrumb = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var customizePrefixCls = props.prefixCls,
    children = props.children,
    separator = props.separator,
    className = props.className,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  var _useLocalization = useLocalization(),
    t = _useLocalization.t;
  var prefixCls = customizePrefixCls ? customizePrefixCls + "-breadcrumb" : 'ap-breadcrumb';
  var count = React.Children.count(children);
  var clones = React.Children.toArray(children).map(function (child, index) {
    return /*#__PURE__*/cloneElement(child, {
      prefixCls: prefixCls,
      separator: separator,
      currentPage: index + 1 === count
    });
  });
  return /*#__PURE__*/React.createElement("nav", _extends({
    ref: ref,
    "aria-label": t('aria').breadcrumbLabel,
    className: ClassNames(prefixCls, className)
  }, rest), /*#__PURE__*/React.createElement("ol", {
    className: prefixCls + "-ol"
  }, clones));
});
export default Breadcrumb;
Breadcrumb.displayName = 'Breadcrumb';